import Vue from 'vue'
import Vuex from 'vuex'
import generalConfig from './modules/general-config'

import videoComments from './modules/workspace/video-comments.js'
import zonningConfig from './modules/zonnig-config.js'

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';


// A Vuex instance is created by combining the state, mutations, actions,
// and getters.
export default new Vuex.Store({
    modules: {
        generalConfig,
        videoComments,
        zonningConfig

    },
    strict: debug
});



// WEBPACK FOOTER //
// ./src/store/index_simple.js